module.exports = __webpack_public_path__ + "img/延华智能-1.c49d7836.png";